export const exhibitionOptionsPermi = [
  { label: 'Exibir com pendência', name: 'boExibirPendencias' },
];

export const permissionaryReportLayout = [
  { label: 'Relatório de Permissionários', value: 6 },
  { label: 'Relatório de CEPEs', value: 5 },
]

export const situacoesPermissionario = [
  { label: "Ativos", value: 1 },
  { label: "Inativos", value: 2 },
  { label: "Todos", value: 3 }
];

export const situacoesLinha = [
  { label: "Ativas", value: 1 },
  { label: "Inativas", value: 2 },
  { label: "Todas", value: 3 }
];
